var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"spinner-block"},[_c('div',{staticClass:"spinner-box"},[_c('dot-loader',{attrs:{"loading":_vm.loading,"color":"rgb(16, 42, 69)","size":"60px"}})],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }